import { Client as StyletronClient } from 'styletron-engine-atomic';

// It is extracted to a separate module to prevent the client to be created
// on each hot module reloading. So on reloading of the "render" the client
// will be the same and styles won't break
const styletronClient = new StyletronClient();

export default styletronClient;
